<!-- 各区域排名 -->
<template>
  <div class="inspection-regional-ranking">
    <div class="ranking-list">
      <div class="list-header">
        <div class="header-cell rank">{{ $t('排名') }}</div>
        <div class="header-cell region">{{ $t('区域名称') }}</div>
        <div class="header-cell completion">{{ $t('完成情况') }}</div>
      </div>
      
      <div class="list-content">
        <div 
          v-for="(item, index) in list" 
          :key="index"
          class="ranking-row"
          :class="`rank-${index + 1}`"
        >
          <div class="ranking-cell rank">
            <div class="rank-badge" :class="`rank-${index + 1}`">
              {{ index + 1 }}
            </div>
          </div>
          <div class="ranking-cell region">{{ item.planName }}</div>
          <div class="ranking-cell completion">
            <div class="completion-bar">
              <div class="completion-progress" :style="{ width: (item.taskFinishRate * 100) + '%' }"></div>
            </div>
            <div class="completion-value">{{ (item.taskFinishRate * 100).toFixed(1) }}%</div>
          </div>
        </div>
        
        <div v-if="list.length === 0" class="empty-state">
          <div class="empty-icon">📋</div>
          <div class="empty-text">{{ $t('暂无区域排名数据') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { postAction } from '@/api/manage'
export default {
    props: {
      dataContainer: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
        return{
            title: this.$t('本月各区域排名'),
            url:{
              LargeScreenSumAreaRankByTime: "/jeecg-engineering/inspection/inspectionTask/LargeScreenSumAreaRankByTime",
            },
            list:[],
        }
    },
    mounted() {
      this.init()
      this.setupContainerRefresh()
    },
    beforeDestroy() {
      this.cleanupContainerRefresh()
    },
    methods: {
      init() {
        this.getData();
      },
      getData(){
        postAction(this.url.LargeScreenSumAreaRankByTime,{queryType:1}).then(res=>{
          if(res.success){
            const data = res.result;
            this.list = data;
          } else {
            this.loadMockData()
          }
        }).catch(() => {
          this.loadMockData()
        })
      },
      loadMockData() {
        this.list = [
          { planName: '高新区', taskFinishRate: 0.95 },
          { planName: '滨江区', taskFinishRate: 0.92 },
          { planName: '西湖区', taskFinishRate: 0.89 },
          { planName: '上城区', taskFinishRate: 0.87 },
          { planName: '下城区', taskFinishRate: 0.85 },
          { planName: '江干区', taskFinishRate: 0.83 },
          { planName: '拱墅区', taskFinishRate: 0.81 },
          { planName: '余杭区', taskFinishRate: 0.79 }
        ]
      },
      setupContainerRefresh() {
        if (this.dataContainer && this.dataContainer.onRefresh) {
          this.dataContainer.onRefresh = this.refreshData
        }
      },
      cleanupContainerRefresh() {
        if (this.dataContainer && this.dataContainer.onRefresh) {
          this.dataContainer.onRefresh = null
        }
      },
      refreshData() {
        this.getData()
      }
    },
}
</script>
<style lang="less" scoped>
.inspection-regional-ranking {
  height: 100%;
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.ranking-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-title {
  color: #b6deff;
  font-size: 16px;
  font-weight: 500;
}

.header-subtitle {
  color: #8BA6C6;
  font-size: 12px;
}

.ranking-list {
  flex: 1;
  background: rgba(0, 48, 111, 0.2);
  border: 1px solid rgba(0, 170, 255, 0.2);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.list-header {
  display: flex;
  align-items: center;
  padding: 4px 7px;
  background: linear-gradient(135deg, rgba(1, 32, 67, 0.8) 0%, rgba(0, 48, 111, 0.6) 100%);
  border-bottom: 1px solid rgba(0, 170, 255, 0.2);
}

.header-cell {
  color: #b6deff;
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  
  &.rank {
    width: 15%;
  }
  
  &.region {
    width: 45%;
  }
  
  &.completion {
    width: 40%;
  }
}

.list-content {
  flex: 1;
  overflow-y: auto;
  padding: 5px 0;
}

.ranking-row {
  display: flex;
  align-items: center;
  padding: 4px 6px;
  border-bottom: 1px solid rgba(0, 170, 255, 0.1);
  transition: all 0.3s ease;
  
  &:last-child {
    border-bottom: none;
  }
  
  &:hover {
    background: rgba(0, 170, 255, 0.05);
  }
  
  &.rank-1 {
    background: linear-gradient(135deg, rgba(255, 184, 0, 0.1) 0%, rgba(255, 184, 0, 0.05) 100%);
    border-left: 3px solid #FFB800;
  }
  
  &.rank-2 {
    background: linear-gradient(135deg, rgba(192, 192, 192, 0.1) 0%, rgba(192, 192, 192, 0.05) 100%);
    border-left: 3px solid #C0C0C0;
  }
  
  &.rank-3 {
    background: linear-gradient(135deg, rgba(205, 127, 50, 0.1) 0%, rgba(205, 127, 50, 0.05) 100%);
    border-left: 3px solid #CD7F32;
  }
}

.ranking-cell {
  &.rank {
    width: 15%;
    display: flex;
    justify-content: center;
  }
  
  &.region {
    width: 45%;
    color: #fff;
    font-size: 13px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  &.completion {
    width: 40%;
    display: flex;
    align-items: center;
    gap: 8px;
  }
}

.rank-badge {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: bold;
  color: #fff;
  
  &.rank-1 {
    background: linear-gradient(135deg, #FFB800, #FF8C00);
    box-shadow: 0 2px 8px rgba(255, 184, 0, 0.3);
  }
  
  &.rank-2 {
    background: linear-gradient(135deg, #C0C0C0, #808080);
    box-shadow: 0 2px 8px rgba(192, 192, 192, 0.3);
  }
  
  &.rank-3 {
    background: linear-gradient(135deg, #CD7F32, #A0522D);
    box-shadow: 0 2px 8px rgba(205, 127, 50, 0.3);
  }
  
  &:not(.rank-1):not(.rank-2):not(.rank-3) {
    background: rgba(0, 170, 255, 0.2);
    border: 1px solid rgba(0, 170, 255, 0.3);
    color: #8BA6C6;
  }
}

.completion-bar {
  flex: 1;
  height: 6px;
  background: rgba(8, 48, 111, 0.6);
  border-radius: 3px;
  overflow: hidden;
}

.completion-progress {
  height: 100%;
  background: linear-gradient(90deg, #00E4FF, #00FF88);
  border-radius: 3px;
  transition: width 0.8s ease;
}

.completion-value {
  color: #00E4FF;
  font-size: 12px;
  font-weight: bold;
  min-width: 35px;
  text-align: right;
}

.empty-state {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px;
  color: #8BA6C6;
}

.empty-icon {
  font-size: 48px;
  opacity: 0.5;
}

.empty-text {
  font-size: 14px;
}

.list-content::-webkit-scrollbar {
  width: 4px;
}

.list-content::-webkit-scrollbar-track {
  background: rgba(0, 48, 111, 0.2);
  border-radius: 2px;
}

.list-content::-webkit-scrollbar-thumb {
  background: rgba(0, 170, 255, 0.3);
  border-radius: 2px;
}

@media (max-width: 1600px) {
  .inspection-regional-ranking {
    padding: 10px;
    gap: 10px;
  }
  
  .ranking-row {
    padding: 6px 12px;
  }
  
  .rank-badge {
    width: 22px;
    height: 22px;
    font-size: 10px;
  }
  
  .completion-value {
    font-size: 11px;
  }
}

@media (max-width: 1200px) {
  .header-title {
    font-size: 14px;
  }
  
  .header-subtitle {
    font-size: 11px;
  }
  
  .ranking-row {
    padding: 5px 10px;
  }
  
  .ranking-cell {
    &.region {
      font-size: 12px;
    }
    
    &.completion {
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;
    }
  }
  
  .completion-value {
    font-size: 10px;
  }
}
</style>